import React from 'react';
import { Tooltip } from '@material-ui/core';
import {
  STATUS_AS_CONFIG,
  STATUS_AS_DEFAULT_CONFIG,
} from './statusIntegracaoASBadge.constants';

export default function StatusIntegracaoASDot({ status }) {
  const config = STATUS_AS_CONFIG[status] ?? STATUS_AS_DEFAULT_CONFIG;

  return (
    <Tooltip title={config.label}>
      <span
        style={{
          display: 'inline-block',
          width: 12,
          height: 12,
          borderRadius: '50%',
          backgroundColor: config.color,
          cursor: 'default',
        }}
      />
    </Tooltip>
  );
}
